import React from 'react';
import { string, oneOfType, number, bool, shape } from 'prop-types';
import { currencyFormatter } from '@magalu/stereo-ui-utils';
import { ProductMiniatureContent, PriceMiniatureLabel, PriceMiniature, EmptyPrice } from './price-miniature.style';
import { inCash } from '../price.text';

const PriceMiniatureComponent = ({
  price,
  paymentMethodDescription,
  showInCashInfo,
  style
}) => {
  if (!price) return /*#__PURE__*/React.createElement(EmptyPrice, {
    "data-testid": "empty-price-miniature"
  });
  return /*#__PURE__*/React.createElement(ProductMiniatureContent, style, /*#__PURE__*/React.createElement(PriceMiniature, {
    "data-testid": "price-miniature"
  }, currencyFormatter({
    value: price
  }), ' ', showInCashInfo && /*#__PURE__*/React.createElement(PriceMiniatureLabel, null, paymentMethodDescription || inCash)));
};

process.env.NODE_ENV !== "production" ? PriceMiniatureComponent.propTypes = {
  price: oneOfType([string, number]),
  paymentMethodDescription: string,
  showInCashInfo: bool,
  style: shape({})
} : void 0;
PriceMiniatureComponent.defaultProps = {
  price: '',
  paymentMethodDescription: '',
  showInCashInfo: false,
  style: {}
};
export default PriceMiniatureComponent;